export class CartPage {
    secureMyBookingBlock: HTMLDivElement; // attribute: data-secure-my-booking
    hideSecureMyBookingBlock: HTMLButtonElement; // attribute: data-hide-smb

    constructor() {
        this.secureMyBookingBlock = document.querySelector('[data-secure-my-booking]') as HTMLDivElement;
        this.hideSecureMyBookingBlock = document.querySelector('[data-hide-smb]') as HTMLButtonElement;

        if (this.hideSecureMyBookingBlock && this.secureMyBookingBlock) {
            this.hideSecureMyBookingBlock.addEventListener('click', () => {
                this.secureMyBookingBlock.classList.add('hide');
            });
        }
    }
}